import { render } from "./BodyTroops.vue?vue&type=template&id=f1b0af34"
import script from "./BodyTroops.vue?vue&type=script&lang=js"
export * from "./BodyTroops.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/BodyTroops.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1b0af34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1b0af34', __exports__)) {
    api.reload('f1b0af34', __exports__)
  }
  
  module.hot.accept("./BodyTroops.vue?vue&type=template&id=f1b0af34", () => {
    api.rerender('f1b0af34', render)
  })

}


export default __exports__